import { useEffect } from "react";

import GlobalStyles from "./assets/GlobalStyles";
import TokenInspector from "./components/TokenInspector";
import { AuthProvider } from "./contexts/auth";
import AuthRoutes from "./routes/AuthRoutes";
import { SignedRoutes } from "./routes/SignedRoutes";

import { FlushAll } from "./assets/functions/cache";
import ErrorBoundary from "./modules/ErrorCat";
import { OverlayProvider } from "./screens/checkout/OverlayContext";

import "./index.css";

function App() {
  useEffect(() => {
    FlushAll();
  }, []);

  return (
    <div
      className={`App ${localStorage.getItem("darkMode") === "true" ? "dark" : ""} transition-colors`}
    >
      <div className="bg-white dark:bg-zinc-900">
        <ErrorBoundary>
          <OverlayProvider>
            <TokenInspector />

            <AuthProvider
              signedComponent={<SignedRoutes />}
              unsignedComponent={<AuthRoutes />}
            />
          </OverlayProvider>
        </ErrorBoundary>
        <GlobalStyles />
      </div>
    </div>
  );
}

export default App;
